import { Link } from "react-router-dom";

export default function Logo({ className = "" }) {
  return (
    <Link
      to="/"
      className={`inline-flex items-center ${className}`}
      data-testid="brand-logo"
    >
      {/* Mobile: stacked. FOTON aligned with "E" in ENDUROSKOLA, tight under */}
      {/* Desktop: horizontal with vertical divider */}
      <div className="flex flex-col items-start sm:flex-row sm:items-center sm:gap-3">
        <img
          src="/assets/logo.png"
          alt="Enduroskola"
          className="h-8 sm:h-10 w-auto object-contain"
          loading="eager"
        />
        <span
          className="block sm:inline-block font-display font-black uppercase text-brand text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] -mt-1 sm:mt-0 pl-[44px] sm:pl-3 sm:border-l sm:border-white/20 leading-none"
        >
          FOTON
        </span>
      </div>
    </Link>
  );
}
